var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.65869H18.1765C18.2456 4.65869 18.3015 4.71466 18.3015 4.78369V13.1751C18.3015 13.6584 18.6933 14.0501 19.1765 14.0501C19.6598 14.0501 20.0515 13.6584 20.0515 13.1751V4.78369C20.0515 3.74816 19.2121 2.90869 18.1765 2.90869H4C3.51675 2.90869 3.125 3.30044 3.125 3.78369C3.125 4.26694 3.51675 4.65869 4 4.65869ZM15.5 6.28369H1C0.447715 6.28369 0 6.73141 0 7.28369V16.2837C0 16.836 0.447715 17.2837 1 17.2837H15.5C16.0523 17.2837 16.5 16.836 16.5 16.2837V7.28369C16.5 6.73141 16.0523 6.28369 15.5 6.28369ZM1.75 13.2837V10.2837C2.99264 10.2837 4 9.27633 4 8.03369H12.5C12.5 9.27633 13.5074 10.2837 14.75 10.2837V13.2837C13.5074 13.2837 12.5 14.2911 12.5 15.5337H4C4 14.2911 2.99264 13.2837 1.75 13.2837ZM9.75 11.7837C9.75 12.6121 9.07843 13.2837 8.25 13.2837C7.42157 13.2837 6.75 12.6121 6.75 11.7837C6.75 10.9553 7.42157 10.2837 8.25 10.2837C9.07843 10.2837 9.75 10.9553 9.75 11.7837Z",
    fill: "#666666"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 21,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.65869H18.1765C18.2456 4.65869 18.3015 4.71466 18.3015 4.78369V13.1751C18.3015 13.6584 18.6933 14.0501 19.1765 14.0501C19.6598 14.0501 20.0515 13.6584 20.0515 13.1751V4.78369C20.0515 3.74816 19.2121 2.90869 18.1765 2.90869H4C3.51675 2.90869 3.125 3.30044 3.125 3.78369C3.125 4.26694 3.51675 4.65869 4 4.65869ZM15.5 6.28369H1C0.447715 6.28369 0 6.73141 0 7.28369V16.2837C0 16.836 0.447715 17.2837 1 17.2837H15.5C16.0523 17.2837 16.5 16.836 16.5 16.2837V7.28369C16.5 6.73141 16.0523 6.28369 15.5 6.28369ZM1.75 13.2837V10.2837C2.99264 10.2837 4 9.27633 4 8.03369H12.5C12.5 9.27633 13.5074 10.2837 14.75 10.2837V13.2837C13.5074 13.2837 12.5 14.2911 12.5 15.5337H4C4 14.2911 2.99264 13.2837 1.75 13.2837ZM9.75 11.7837C9.75 12.6121 9.07843 13.2837 8.25 13.2837C7.42157 13.2837 6.75 12.6121 6.75 11.7837C6.75 10.9553 7.42157 10.2837 8.25 10.2837C9.07843 10.2837 9.75 10.9553 9.75 11.7837Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.a98e620cfc57defddcdc2282ee6eb07f.svg";
export { ForwardRef as ReactComponent };